import React from "react";
import Icon from "../icon/Icon";
const ManagementControl = ({ icon, onClick, text }) => /* @__PURE__ */ React.createElement("div", { className: "cursor-pointer select-none flex", onClick }, /* @__PURE__ */ React.createElement("div", { className: "mr-2 w-4" }, /* @__PURE__ */ React.createElement(Icon, { alt: `${text} icon`, icon })), /* @__PURE__ */ React.createElement("span", { className: "font-normal" }, text));
export default ManagementControl;
